import * as React from 'react'
import { useWatch } from 'react-hook-form'
import Control from './controls'
import Fieldset from './Fieldset'
import Smart from './Smart'

export default function Renderer(props) {
    if (!Array.isArray(props.items)) {
        return null
    }

    return (
        <Smart>
            {props.items.map(item => (
                <Item key={item.name} {...item} />
            ))}
        </Smart>
    )
}

function Item({ filter, ...props }) {
    if (Array.isArray(filter)) {
        return <FilteredItem filter={filter} {...props} />
    }

    switch (props.type) {
        case 'fieldset':
            return (
                <Fieldset {...props}>
                    <Renderer {...props} />
                </Fieldset>
            )
        case 'control':
            return <Control {...props} />
        default:
            return null
    }
}

// https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/
// ['in', 'activity', ['ski', 'sled']]

function FilteredItem({ filter, ...props }) {
    const [operator, name, values] = filter

    if (!OPERATORS.has(operator)) {
        throw new TypeError(`Filter: operator of type "${operator}" is not supported.`)
    }

    const value = useWatch({ name })
    const predicate = React.useCallback(
        value => {
            function predicate(value) {
                return values.includes(value)
            }

            if (Array.isArray(value)) {
                return value.some(predicate)
            }

            return predicate(value)
        },
        [values]
    )

    return predicate(value) ? <Item {...props} /> : null
}

const OPERATORS = new Set(['in'])
